var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore-next-line
import { Dimensions, Animated, Linking, Image, Easing, View } from 'react-native';
import { AnimatedScreen } from "./AnimatedScreen";
import React, { useEffect, useRef, useState } from "react";
import { Flex, LorecraftPopup, StyledText } from "../Components";
import { isScreenSmall } from "../Helpers";
import logo from "../assets/logo.png";
import title from "../assets/title.png";
import lorecraftBox from "../assets/lorecraftBox.png";
import lorecraftBackground from "../assets/lorecraftBackground.jpg";
import lorecraftSteps from "../assets/lorecraftSteps.png";
import lorecraftStepsVerticle from "../assets/lorecraftStepsVerticle.png";
import lorecraftCards from "../assets/lorecraftCards.png";
import lorecraftDescriptionWide from "../assets/lorecraftDescriptionWide.png";
import lorecraftDescriptionNarrow from "../assets/lorecraftDescriptionNarrow.png";
var WAITLIST_SIGNUP_URL = 'https://getwaitlist.com/api/v1/signup';
var WAITLIST_ID = 8254;
var WAITLIST_SUCCESS_COLOR = '#22C55E';
var WAITLIST_ERROR_COLOR = '#EF4444';
// It animates in and out using the usual AnimatedScreen
export var LorecraftScreen = function (_a) {
    var _b;
    var route = _a.route;
    var smallScreen = isScreenSmall();
    // initial screen appearing animations
    var logoOpacity = useRef(new Animated.Value(0)).current;
    var titleOpacity = useRef(new Animated.Value(0)).current;
    var restOpacity = useRef(new Animated.Value(0)).current;
    var logoOffset = useRef(new Animated.Value(0)).current;
    var headerOffset = useRef(new Animated.Value(0)).current;
    var titleOffset = useRef(new Animated.Value(-40)).current;
    var _c = useState(0), lorecraftHeight = _c[0], setLorecraftHeight = _c[1];
    var _d = useState(''), resultText = _d[0], setResultText = _d[1];
    var _e = useState(WAITLIST_SUCCESS_COLOR), resultColor = _e[0], setResultColor = _e[1];
    var _f = useState(false), resultVisible = _f[0], setResultVisible = _f[1];
    var _g = useState(0), resultContentHeight = _g[0], setResultContentHeight = _g[1];
    var _h = useState(false), waitlistPopupVisible = _h[0], setWaitlistPopupVisible = _h[1];
    var _j = useState(false), waitlistSubmitting = _j[0], setWaitlistSubmitting = _j[1];
    var resultOpacity = useRef(new Animated.Value(0)).current;
    var resultContainerProgress = useRef(new Animated.Value(0)).current;
    var resultAnimationRef = useRef(null);
    useEffect(function () {
        Animated.sequence([
            Animated.timing(logoOpacity, {
                toValue: 1,
                duration: 1500,
                useNativeDriver: false
            }),
            Animated.parallel([
                Animated.timing(titleOpacity, {
                    toValue: 1,
                    duration: 1000,
                    useNativeDriver: false
                }),
                Animated.timing(logoOffset, {
                    toValue: smallScreen ? 75 : 175,
                    duration: 1000,
                    useNativeDriver: false
                }),
                Animated.timing(titleOffset, {
                    toValue: smallScreen ? -75 : -125,
                    duration: 1000,
                    useNativeDriver: false
                }),
                Animated.timing(restOpacity, {
                    toValue: 1,
                    duration: 1250,
                    useNativeDriver: false
                }),
            ]),
        ]).start();
    }, []);
    var showWaitlistResult = function (status, message) {
        var _a;
        setResultColor(status === 'success' ? WAITLIST_SUCCESS_COLOR : WAITLIST_ERROR_COLOR);
        setResultText(message);
        setResultVisible(true);
        (_a = resultAnimationRef.current) === null || _a === void 0 ? void 0 : _a.stop();
        resultContainerProgress.stopAnimation();
        resultOpacity.stopAnimation();
        resultContainerProgress.setValue(0);
        resultOpacity.setValue(0);
        var animation = Animated.sequence([
            Animated.parallel([
                Animated.timing(resultContainerProgress, {
                    toValue: 1,
                    duration: 250,
                    easing: Easing.out(Easing.cubic),
                    useNativeDriver: false,
                }),
                Animated.timing(resultOpacity, {
                    toValue: 1,
                    duration: 200,
                    useNativeDriver: true,
                }),
            ]),
            Animated.delay(5000),
            Animated.parallel([
                Animated.timing(resultOpacity, {
                    toValue: 0,
                    duration: 200,
                    useNativeDriver: true,
                }),
                Animated.timing(resultContainerProgress, {
                    toValue: 0,
                    duration: 250,
                    easing: Easing.in(Easing.cubic),
                    useNativeDriver: false,
                }),
            ]),
        ]);
        resultAnimationRef.current = animation;
        animation.start(function (_a) {
            var finished = _a.finished;
            if (finished) {
                setResultVisible(false);
                setResultText('');
            }
            resultAnimationRef.current = null;
        });
    };
    var submitWaitlistEmail = function (emailInput) { return __awaiter(void 0, void 0, void 0, function () {
        var email, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    email = (emailInput || '').trim();
                    setWaitlistSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, fetch(WAITLIST_SIGNUP_URL, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({ email: email, waitlist_id: WAITLIST_ID }),
                        })];
                case 2:
                    response = _a.sent();
                    if (response.ok) {
                        showWaitlistResult('success', 'Success! You are on the waitlist.');
                        return [2 /*return*/, true];
                    }
                    else {
                        showWaitlistResult('error', 'Something went wrong. Please try again.');
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    showWaitlistResult('error', 'Network error. Please try again later.');
                    return [2 /*return*/, false];
                case 4:
                    setWaitlistSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleWaitlistPress = function () {
        setWaitlistPopupVisible(true);
    };
    var handleWaitlistPopupClose = function () {
        if (!waitlistSubmitting) {
            setWaitlistPopupVisible(false);
        }
    };
    var handleWaitlistSubmit = function (value) { return __awaiter(void 0, void 0, void 0, function () {
        var success;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, submitWaitlistEmail(value)];
                case 1:
                    success = _a.sent();
                    if (success) {
                        setWaitlistPopupVisible(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // scrolling animations
    var animatedScrollYValue = useRef(new Animated.Value(0)).current;
    var headerHeight = smallScreen ? 150 : 200;
    //const drift = smallScreen ? 25 : 50
    var drift = 0;
    var bottomTextDriftOffset = smallScreen ? 200 : 0;
    var imageZoom = useRef(new Animated.Value(1)).current;
    var textZoom = useRef(new Animated.Value(1)).current;
    var textDriftLeft = useRef(new Animated.Value(-drift)).current;
    var textDriftRight = useRef(new Animated.Value(drift)).current;
    useEffect(function () {
        Animated.timing(imageZoom, {
            toValue: animatedScrollYValue.interpolate({
                inputRange: [0, headerHeight],
                outputRange: [1, 0.75],
                extrapolate: 'clamp',
            }),
            easing: Easing.linear,
            duration: 250,
            useNativeDriver: true,
        }).start();
        Animated.timing(textZoom, {
            toValue: animatedScrollYValue.interpolate({
                inputRange: [0, headerHeight],
                outputRange: [1, 1.25],
                extrapolate: 'clamp',
            }),
            easing: Easing.linear,
            duration: 250,
            useNativeDriver: true,
        }).start();
        // disable drifting animations for now, they work fine but the design is meh
        /*
        Animated.timing(textDriftLeft, {
          toValue: animatedScrollYValue.interpolate({
            inputRange: [0, headerHeight, headerHeight * 2, headerHeight * 3],
            outputRange: [-drift, 0, 0, drift],
            extrapolate: 'clamp',
          }),
          easing: Easing.linear,
          duration: 350,
          useNativeDriver: true,
        }).start();
    
        Animated.timing(textDriftRight, {
          toValue: animatedScrollYValue.interpolate({
            inputRange: [0, headerHeight * 2 + bottomTextDriftOffset, headerHeight * 3 + bottomTextDriftOffset, headerHeight * 4 + bottomTextDriftOffset],
            outputRange: [drift, 0, 0, -drift],
            extrapolate: 'clamp',
          }),
          easing: Easing.linear,
          duration: 350,
          useNativeDriver: true,
        }).start();
        */
    }, [animatedScrollYValue, headerHeight, bottomTextDriftOffset, drift]);
    var infoStyle = {
        marginTop: 25
    };
    var headerStyle = {
        marginTop: smallScreen ? 75 : 100,
    };
    var textStyle = {
        textAlign: 'center',
        textShadowColor: '#5B80A0',
        textShadowOffset: { width: 2, height: 2 },
        textShadowRadius: 2,
    };
    var fallbackResultHeight = smallScreen ? 28 : 34;
    var targetResultHeight = (resultContentHeight || fallbackResultHeight);
    var resultContainerHeight = resultContainerProgress.interpolate({
        inputRange: [0, 1],
        outputRange: [0, targetResultHeight],
    });
    return (_jsxs(AnimatedScreen, __assign({ fadeIn: !smallScreen, fadeOut: (_b = route === null || route === void 0 ? void 0 : route.params) === null || _b === void 0 ? void 0 : _b.fadeOut }, { children: [_jsx(Animated.ScrollView, __assign({ style: { height: 1 }, onScroll: Animated.event([{ nativeEvent: { contentOffset: { y: animatedScrollYValue } } }], { useNativeDriver: true }), scrollEventThrottle: 100 }, { children: _jsxs(Flex, __assign({ fullWidth: true, centered: true }, { children: [_jsxs(Animated.View, __assign({ style: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: 1,
                                marginTop: headerHeight,
                                marginBottom: headerHeight,
                                transform: [{ translateY: headerOffset }]
                            } }, { children: [_jsx(Animated.View, __assign({ style: {
                                        position: 'absolute',
                                        opacity: titleOpacity,
                                        transform: [
                                            {
                                                translateX: titleOffset,
                                                translateY: -150,
                                            }
                                        ]
                                    } }, { children: _jsx(StyledText, __assign({ type: smallScreen ? "body" : "header" }, { children: "LaPlante Studios" })) })), _jsx(Animated.View, __assign({ style: {
                                        position: 'absolute',
                                        opacity: logoOpacity,
                                        transform: [
                                            {
                                                translateX: logoOffset
                                            }
                                        ]
                                    } }, { children: _jsx(Image, { source: logo, style: {
                                            width: smallScreen ? 125 : 250,
                                            height: smallScreen ? 125 : 250,
                                        } }) }))] })), _jsx(Animated.View, __assign({ style: { opacity: restOpacity }, onLayout: function (event) { return setLorecraftHeight(event.nativeEvent.layout.height); } }, { children: _jsxs(Flex, __assign({ style: { paddingHorizontal: 50 }, centered: true }, { children: [_jsx(Image, { source: lorecraftBackground, style: {
                                            width: Dimensions.get('window').width,
                                            height: lorecraftHeight,
                                            top: 0,
                                            position: 'absolute',
                                            zIndex: -1,
                                        }, resizeMode: 'stretch' }), _jsx(Animated.Image, { source: title, style: {
                                            width: smallScreen ? 300 : 600,
                                            height: smallScreen ? 125 : 250,
                                            transform: [{ scale: imageZoom }]
                                        } }), _jsxs(View, __assign({ style: {
                                            marginBottom: 25,
                                            alignItems: 'center',
                                            width: '100%'
                                        } }, { children: [_jsx(StyledText, __assign({ animated: true, type: smallScreen ? "caption" : "body", style: __assign({ transform: [{ translateX: textDriftLeft }, { scale: textZoom }] }, textStyle), onPress: handleWaitlistPress }, { children: "Join the waitlist, click here!" })), _jsx(Animated.View, __assign({ style: {
                                                    marginTop: 4,
                                                    width: '100%',
                                                    overflow: 'hidden',
                                                    alignItems: 'center',
                                                    height: resultContainerHeight,
                                                } }, { children: resultVisible && (_jsx(Animated.Text, __assign({ onLayout: function (event) { return setResultContentHeight(event.nativeEvent.layout.height); }, style: {
                                                        paddingTop: 50,
                                                        color: resultColor,
                                                        opacity: resultOpacity,
                                                        textAlign: 'center',
                                                        fontSize: smallScreen ? 16 : 20,
                                                        fontFamily: 'System'
                                                    } }, { children: resultText }))) }))] })), _jsxs(Flex, __assign({ row: true, wrap: true, centered: true }, { children: [_jsx(Flex, __assign({ style: { marginHorizontal: 50, marginVertical: 25 } }, { children: _jsx("iframe", { width: smallScreen ? "280" : "560", height: smallScreen ? "160" : "315", src: "https://www.youtube.com/embed/OjyGHSUeTyg", title: "YouTube video player", frameBorder: "0", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", allowFullScreen: true }) })), _jsx(Flex, __assign({ style: { marginHorizontal: 50, marginVertical: 25 } }, { children: _jsx(Image, { source: lorecraftBox, style: {
                                                        width: smallScreen ? 180 : 360,
                                                        height: smallScreen ? 294 : 588,
                                                        borderRadius: smallScreen ? 8 : 16
                                                    } }) }))] })), _jsx(StyledText, __assign({ type: smallScreen ? "caption" : "body", animated: true, style: __assign({ marginTop: 25, transform: [{ translateX: textDriftRight }, { scale: textZoom }] }, textStyle), onPress: function () { return Linking.openURL("https://boardgamegeek.com/boardgame/398730/lorecraft"); } }, { children: "See on Board Game Geek,".concat(smallScreen ? '\n' : '', " click here!") })), _jsx(Flex, __assign({ style: { marginVertical: smallScreen ? 50 : 100 } }, { children: _jsx(Image, { source: smallScreen ? lorecraftDescriptionNarrow : lorecraftDescriptionWide, style: {
                                                width: smallScreen ? 217 : 1133,
                                                height: smallScreen ? 135 : 120,
                                            } }) })), _jsxs(Flex, __assign({ row: true, wrap: true, centered: true, style: { paddingBottom: 75 } }, { children: [_jsx(Image, { source: smallScreen ? lorecraftStepsVerticle : lorecraftSteps, style: {
                                                    width: smallScreen ? 389 : 980,
                                                    height: smallScreen ? 739 : 664,
                                                } }), _jsx(Image, { source: lorecraftCards, style: {
                                                    width: smallScreen ? 200 : 499,
                                                    height: smallScreen ? 257 : 642,
                                                    marginTop: smallScreen ? 50 : 0,
                                                } })] })), _jsxs(View, __assign({ style: {
                                            paddingBottom: 50,
                                            alignItems: 'center',
                                            width: '100%'
                                        } }, { children: [_jsx(StyledText, __assign({ animated: true, type: smallScreen ? "caption" : "body", style: __assign({ transform: [{ translateX: textDriftLeft }, { scale: textZoom }] }, textStyle), onPress: handleWaitlistPress }, { children: "Join the waitlist, click here!" })), _jsx(Animated.View, __assign({ style: {
                                                    marginTop: 4,
                                                    width: '100%',
                                                    overflow: 'hidden',
                                                    alignItems: 'center',
                                                    height: resultContainerHeight,
                                                } }, { children: resultVisible && (_jsx(Animated.Text, __assign({ onLayout: function (event) { return setResultContentHeight(event.nativeEvent.layout.height); }, style: {
                                                        paddingTop: 50,
                                                        color: resultColor,
                                                        opacity: resultOpacity,
                                                        textAlign: 'center',
                                                        fontSize: smallScreen ? 16 : 20,
                                                        fontFamily: 'System'
                                                    } }, { children: resultText }))) }))] }))] })) })), _jsx(Animated.View, __assign({ style: { opacity: restOpacity } }, { children: _jsxs(Flex, __assign({ style: { paddingHorizontal: 50 }, centered: true }, { children: [_jsx(StyledText, __assign({ type: "body", style: headerStyle }, { children: "About" })), _jsx(StyledText, __assign({ type: "caption", style: infoStyle }, { children: "We're a small studio of just 2 people making games that inspire creativity, strategy, and laughter. If that's something you like, then you're pretty cool" })), _jsx(StyledText, __assign({ type: "body", style: headerStyle }, { children: "Contact Us" })), _jsx(StyledText, __assign({ type: "caption", style: infoStyle, onPress: function () { return Linking.openURL("mailto:bmbmjmdm@gmail.com"); } }, { children: "Just click here it's easy" })), _jsx(View, { style: { height: 100 } })] })) }))] })) })), _jsx(LorecraftPopup, { visible: waitlistPopupVisible, onClose: handleWaitlistPopupClose, onSubmit: handleWaitlistSubmit, loading: waitlistSubmitting, accentColor: "#5B80A0" })] })));
};
